import {Alert, AlertDescription, AlertTitle} from "@/components/ui/alert";
import {useStoredMeProperties} from "@/src/modules/core/store/me";
import {useStoredUserProperty} from "@/src/modules/core/store/user-property";
import {buildAmenityRestrictionReferralMessage} from "@/src/modules/properties/lib/property-manager-contact";
import type {Property} from "@/src/modules/properties/types";

type HouseholdAmenityRestrictionBannerProps = {
  className?: string;
  /** When set, resolves `property_managers` from `me.properties` for this property. */
  propertyId?: number | null;
};

function resolvePropertyForManagers(
  propertyId: number | null | undefined,
  meProperties: Property[],
  userProperty: Property | null,
): Property | null {
  if (propertyId != null) {
    return meProperties.find((p) => p.id === propertyId) ?? userProperty;
  }
  return userProperty ?? meProperties[0] ?? null;
}

export function HouseholdAmenityRestrictionBanner({
  className,
  propertyId,
}: HouseholdAmenityRestrictionBannerProps) {
  const meProperties = useStoredMeProperties();
  const userProperty = useStoredUserProperty();
  const property = resolvePropertyForManagers(propertyId, meProperties, userProperty);
  const {lead, propertyManagerLine} = buildAmenityRestrictionReferralMessage(property?.property_managers);

  return (
    <Alert variant="destructive" className={className}>
      <AlertTitle>Amenity access restricted</AlertTitle>
      <AlertDescription className="flex flex-col gap-1">
        <span>{lead}</span>
        {propertyManagerLine ? <span>{propertyManagerLine}</span> : null}
      </AlertDescription>
    </Alert>
  );
}
